<div class="container">
  <div class="title">
    <h3>{{ getTitle() }}</h3>
  </div>

  @if (successMessage) {
    <div class="message">
      <p-message severity="success" [text]="successMessage" />
    </div>
  }

  @if (errorMessage) {
    <div class="message">
      <p-message severity="error" [text]="errorMessage" />
    </div>
  }

  <form [formGroup]="formGroup">
    <div class="field">
      <p-input-group>
        <p-inputgroup-addon>
          <i class="pi pi-cog"></i>
        </p-inputgroup-addon>
        <p-floatlabel variant="on">
          <p-select
            formControlName="provider"
            [options]="availableProviders"
            optionLabel="label"
            id="provider"
            placeholder="Select authentication provider"
            [class.ng-invalid]="formGroup.get('provider')?.invalid && formGroup.get('provider')?.touched"
          />
          <label for="provider">Authentication Provider</label>
        </p-floatlabel>
      </p-input-group>
      @if (formGroup.get('provider')?.invalid && formGroup.get('provider')?.touched) {
        <small class="form-error">Please select an authentication provider</small>
      }
    </div>

    <div class="field">
      <p-input-group>
        <p-inputgroup-addon>
          <i class="pi pi-user"></i>
        </p-inputgroup-addon>
        <p-floatlabel variant="on">
          <input
            pInputText
            formControlName="username"
            type="email"
            id="username"
            [class.ng-invalid]="formGroup.get('username')?.invalid && formGroup.get('username')?.touched"
          />
          <label for="username">Email Address</label>
        </p-floatlabel>
      </p-input-group>
      @if (formGroup.get('username')?.invalid && formGroup.get('username')?.touched) {
        <small class="form-error">Please enter a valid email address</small>
      }
    </div>

    @if (shouldShowField('confirmationCode')) {
      <div class="field">
        <p-input-group>
          <p-inputgroup-addon>
            <i class="pi pi-lock"></i>
          </p-inputgroup-addon>
          <p-floatlabel variant="on">
            <input pInputText formControlName="confirmationCode" type="text" id="confirmationCode" />
            <label for="confirmationCode">Confirmation Code</label>
          </p-floatlabel>
        </p-input-group>
        @if (formGroup.get('confirmationCode')?.invalid && formGroup.get('confirmationCode')?.touched) {
          <small class="form-error">Please enter the confirmation code sent to your email</small>
        }
      </div>
    }

    @if (shouldShowField('newPassword')) {
      <div class="field">
        <p-input-group>
          <p-inputgroup-addon>
            <i class="pi pi-key"></i>
          </p-inputgroup-addon>
          <p-floatlabel variant="on">
            <input pInputText formControlName="newPassword" type="password" id="newPassword" />
            <label for="newPassword">New Password</label>
          </p-floatlabel>
        </p-input-group>
        @if (getPasswordError()) {
          <small class="form-error">{{ getPasswordError() }}</small>
        }
      </div>
    }

    @if (shouldShowField('confirmPassword')) {
      <div class="field">
        <p-input-group>
          <p-inputgroup-addon>
            <i class="pi pi-key"></i>
          </p-inputgroup-addon>
          <p-floatlabel variant="on">
            <input
              pInputText
              formControlName="confirmPassword"
              type="password"
              id="confirmPassword"
              [class.ng-invalid]="
                formGroup.get('confirmPassword')?.invalid && formGroup.get('confirmPassword')?.touched
              "
            />
            <label for="confirmPassword">Confirm New Password</label>
          </p-floatlabel>
        </p-input-group>
        @if (getConfirmPasswordError()) {
          <small class="form-error">{{ getConfirmPasswordError() }}</small>
        }
      </div>
    }

    <p-divider />

    <div class="button-group">
      <p-button
        [label]="showConfirmationForm ? 'Reset Password' : 'Send Reset Code'"
        [loading]="loading"
        [disabled]="!isValid() || loading"
        (click)="onSubmit()"
        fluid="true"
      />
    </div>

    <div class="button-group">
      <p-button type="button" label="Back to Sign In" variant="outlined" (click)="goBackToSignIn()" fluid="true" />
    </div>
  </form>

  @if (shouldShowField('newPassword')) {
    <p-divider />

    <div class="password-requirements">
      <h4>Password Requirements:</h4>
      <ul>
        <li>At least 8 characters long</li>
        <li>At least one lowercase letter</li>
        <li>At least one uppercase letter</li>
        <li>At least one number</li>
        <li>At least one special character (&#64;$!%*?&amp;)</li>
      </ul>
    </div>
  }
</div>
